export default "__VITE_ASSET__C2koo7nc__"